import type {Vec2} from "#material/types/vector"
import {CubicBezierSpline, InterpolationMode, Knot, OutOfBoundsMode, SampledFunction} from "@cm/math"

export function computeRgbCurveSampledFunction(controlPoints: Vec2[]): SampledFunction {
    const sortedControlPoints = [...controlPoints].sort((a, b) => a.x - b.x)
    const numCurveSamples = 256
    const knots = sortedControlPoints.map((point) => new Knot(point))
    const spline = new CubicBezierSpline(knots)
    const points = spline.evaluatePoints(numCurveSamples)
    return new SampledFunction(points, InterpolationMode.Linear, OutOfBoundsMode.Extrapolate)
}

// returns a [lutSize][3] array of numbers which map inputs for R, G and B (mapped between 0 and 1) to their respective output values
export function computeRgbCurveLut(lutSize: number, controlPoints: [Vec2[], Vec2[], Vec2[], (Vec2[] | undefined)?]): [number, number, number][] {
    const sampledFunctions: SampledFunction[] = []
    for (let curveIndex = 0; curveIndex < 4; curveIndex++) {
        const sampledFunction = computeRgbCurveSampledFunction(controlPoints[curveIndex] ?? [])
        sampledFunctions.push(sampledFunction)
    }
    const lut = new Array(lutSize).fill(0).map(() => new Array(3).fill(0)) as [number, number, number][]
    for (let c = 0; c < 3; c++) {
        for (let i = 0; i < lut.length; i++) {
            const input = i / (lut.length - 1)
            const output = sampledFunctions[c].evaluate(sampledFunctions[3].evaluate(input)!)! // we use "extrapolate" so it can not be undefined
            lut[i][c] = output
        }
    }
    return lut
}
